import type { Locale } from '@core/Entities/Locale/Locale.entity';
import type { RegionAreaAtom } from '@search/Atoms/RegionAtom.entity';

export const getFilteredAreas = (
  areas: RegionAreaAtom[],
  selected: RegionAreaAtom | null,
  locale: Locale,
): RegionAreaAtom[] => {
  if (selected?.key === 'any_region') return [];

  if (selected) {
    const filteredAreas = areas.filter(area => {
      const { region } = area;

      return region
        .toLowerCase()
        .includes(
          locale === 'uk' ? selected.region.toLowerCase() : selected.displayName.toLowerCase(),
        );
    });
    return filteredAreas;
  }
  return areas;
};
